// extracted by mini-css-extract-plugin
module.exports = {"badge":"PlanStatusBadge_badge__RJRsu","dot":"PlanStatusBadge_dot__Nsy_K","info":"PlanStatusBadge_info__4hDl1","onGradient":"PlanStatusBadge_onGradient__aUs_b"};